import { v4 as uuidv4 } from 'uuid';

import { getUserIp } from '../cartHelpers';
import { getStore } from '../helpers/localStorageHelpers';
import { LineItem, Order } from '../types';
import { StoreApi as api } from './instances';

export const createOrder = () => {
  const store = getStore();

  const data = store.logged_in
    ? { user_id: store.user_id }
    : { token: store.token };

  return api.post<Order>('/v2/orders/', data);
};

export const getOrder = (orderId: number) =>
  api.get<Order>(`/v2/orders/${orderId}`);

export const addLineItem = async (data: {
  lineItem: LineItem;
  orderId: number;
  eventId: string;
}) => {
  const userIp = await getUserIp();

  const eventData = {
    event_id: data.eventId || uuidv4(),
    user_ip: userIp,
  };
  return api.post<LineItem>(`/v2/orders/${data.orderId}/line-items`, {
    ...eventData,
    ...data.lineItem,
  });
};

export const updateLineItemQuantity = async (data: {
  variantId: number;
  quantity: number;
  orderId: number;
}) => api.post<LineItem>(`/v1/orders/${data.orderId}/line_items`);

export const removeLineItem = async (data: {
  orderId: number;
  lineItemId: number;
}) => api.delete(`/v1/orders/${data.orderId}/line_items/${data.lineItemId}`);
